import axios from 'axios'
import { PENDING_RD, NULL } from '../actionType'

const getToken = () => {
  return localStorage.getItem(process.env.REACT_APP_USERTOKEN)
}

// ** Search table Data
export const getCountries = () => {
  return dispatch => {
    axios.get(`${process.env.REACT_APP_BASEURL}get-countries`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`
      }
    }).then(response => {
      dispatch({
        type: 'COUNTRIES_DATA',
        countries: response.data
      })
    }).catch((error) => {
      dispatch({
        type: 'SEARCH_MANAGE_RD_GET_DATA',
        allData: "response.data.allData",
        manageRDsList: [1, 2, 3, 4],
        totalPages: "response.data.total"
      })
    })
  }
}

// ** Search table Data
export const getStatesById = (country_id) => {
  return dispatch => {
    const formData = new FormData()
    formData.append("country_id", country_id)
    axios.post(`${process.env.REACT_APP_BASEURL}get-states`, formData, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`
      }
    }).then(response => {
      dispatch({
        type: 'STATES_DATA',
        states: response.data
      })
    }).catch((error) => {
      dispatch({
        type: 'SEARCH_MANAGE_RD_GET_DATA',
        allData: "response.data.allData",
        manageRDsList: [1, 2, 3, 4],
        totalPages: "response.data.total"
      })
    })
  }
}

// ** Pending RD Profile
export const getRDProfileInfo = (id) => {
  return dispatch => {
    axios.get(`${process.env.REACT_APP_BASEURL}admin/view-rd-details/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`
      }
    }).then(response => {
      dispatch({
        type: PENDING_RD.PROFILE_INFO,
        profileInfo: response.data.data
      })
    }).catch((error) => {
      dispatch({
        type: PENDING_RD.ERROR,
        error
      })
    })
  }
}

// ** Approve Pending RD Profile
export const approveRDProfile = (id) => {
  return dispatch => {
    axios.post(`${process.env.REACT_APP_BASEURL}admin/approve-rd-profile`, {
      id
    }, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`
      }
    }).then(response => {
      dispatch({
        type: PENDING_RD.PROFILE_APPROVE,
        profileApproval: response.data
      })
    }).catch((error) => {
      dispatch({
        type: PENDING_RD.ERROR,
        error
      })
    })
  }
}

export const nullSearchData = (listName) => {
  return dispatch => {
    switch (listName) {
      case 'pendingRds':
        dispatch({
          type: 'MANAGE_PENDING_RD_SEARCH_DATA',
          searchPendingRds: null
        })
        break
      case NULL.PROFILE_STATUS:
        dispatch({
          type: PENDING_RD.PROFILE_STATUS,
          pendingRDUpdatedStatus: null
        })
        break
    }
  }
}
